module.exports = __webpack_public_path__ + "static/conleys-store-f974266bb95bc4c20aa96b98db0824bc.jpg";